import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/organism/Breadcrumb'
import axios from 'axios'

class LeakageInconnu extends Component {

    constructor(props){
        super(props)
        this.state = {
            serial: this.props.location.state.token,
            errors: [],
        }
    }

    handleReload = event => {
        this.setState({active : true})

        const token = localStorage.getItem('token')
        const config = {
            headers: { 'Authorization': `Bearer ${token}` }
        };

        let bodyFormData = new FormData()
        bodyFormData.set('serial', this.state.serial)
        bodyFormData.set('menuElementId', sessionStorage.getItem('menu'))

        axios.post(process.env.REACT_APP_API_URL+'/Leakage/detail', bodyFormData, config)
            .then(res => {
                if(res.data.data.trouve === true){
                    this.props.history.push({
                        pathname: '/LeakageDetail',
                        state: { detail: res.data.data }
                    })
                }
                else{
                    this.setState({active : false})
                }
            })
            .catch(error =>{
                //console.log(error);
                // erreur 400 = mauvais format
                // erreur 403 = existe pas
                if (error.response.status === 400) {
                    this.setState({errors : error.response.data.errors})
                }
                if (error.response.status === 403) {
                    this.setState({chambreNonTrouvee : true})
                }
            }) 
    }
    
    render() {
        return (
            <Fragment>
                <Breadcrumb titre='Leakage' ico={sessionStorage.getItem('icoMenu')} />
                <div className="vertical-center wrapper-90">
                    <div className="ico__xl ico--alert ico--center mb-xl"></div>
                        <h3 className="text-alert text-center mb-xxxl">Erreur : Le numéro { this.state.serial } saisi est inconnu.</h3>
             
                    <Link className="btn btn-primary text-center mb-xxxl" to="LeakageSaisie">  Entrer un nouveau numéro de boitier </Link>
                    
                    <div className="card">
                        <h5><i className="ico__sm ico--ib ico--warning pr-md"></i>Dépannage</h5>
                        <ul className="list-simple">
                            <li>Penser à vérifier qu’il n’y ai pas d’erreur de saisie pour l’identifiant.</li>
                        </ul>
                    </div>

                </div>
            </Fragment>
        )
    }
}

export default LeakageInconnu